var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('l-map',{staticStyle:{"height":"400px","width":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center,"bounds":_vm.bounds,"max-bounds":_vm.maxBounds}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._v(" "),_c('l-marker',{attrs:{"lat-lng":_vm.marker}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }